import type { FaireProductEntity } from "../../entity_types/product";

export const p_3bu7pwuqmw: FaireProductEntity = {
  token: "p_3bu7pwuqmw",
  type: "product",
  name: "SWEATER KNIT TOP AND PANTS SET / WL25-12403",
  brandToken: "b_1hsvo6fo88",
  brandName: "Wishlist Apparel",
  imageUrl:
    "https://cdn.faire.com/fastly/6cc4732ad8cbb5b419436266afe9019c334358f0fc857026f4e4477ff4d1e423.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/393f20aaa86b78bb62279b2ae0ea7aea65ed90cff558611f4f5b693129b5565c.jpeg",
    "https://cdn.faire.com/fastly/0bae69d47571b7b03f6e5661d4c6843c5c256d56fd4a929712a648b8d2907f89.jpeg",
    "https://cdn.faire.com/fastly/2bfe05de9939f720511a9054ae6a4afa8d4beb812d1b12e0b647f050c2086d05.jpeg",
    "https://cdn.faire.com/fastly/b83eeee28c44b3a3427a6f1d93cec8174398c6da3a4afa4990577018f2ebb115.jpeg",
    "https://cdn.faire.com/fastly/a41664627855c20a265f4fcf4a1078d8987d4bb01bafb98e687a7cb83074b6cf.jpeg",
    "https://cdn.faire.com/fastly/6a24a08deb5ba749ba0f930ff3b83e4c849f84e7821913f24ef1965759699528.jpeg",
    "https://cdn.faire.com/fastly/68f6e942ea19f626cc609542fdb01d2ce79a6412baa84efeecd7c3e73a130815.jpeg",
  ],
  priceDollars: 297,
  description:
    'SWEATER KNIT TOP AND PANTS SET\n- BOTTOM: ELASTIC WAISTBAND, LOOSE AND COMFORTABLE, GREAT FOR EASY WEEKENDS OR LOUNGEWEAR\n\nSMALL: INSEAM LENGTH - 27"\nMODEL IS WEARING SIZE SMALL.\n\n50% VISCOSE, 28% POLYESTER, 22% NYLON\n\n* Due to lighting and differences in monitors, actual colors may vary slightly from what appears online.',
  tags: [],
  msrpDollars: 594,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:55.970Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
